// extracted by mini-css-extract-plugin
export default {"checkout-item-container":"Checkout_checkout-item-container__bRmAw","checkout__alert":"Checkout_checkout__alert__kQHpu"};